import React from 'react';
import ScreenListing from '../components/ScreenListing';

export default (props) => {
  const { data } = props;

  return (
    <>
      <ScreenListing
        {...props}
        datalist={data?.checkout_screen_list}
        buttonType={"checkout_screen"}
      />
    </>
  )
}